import './i18n/config';
import '@/polyfills/scrollend';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import './utils/telemetry';

import routes from './routes.tsx';
import { store } from './store/main';
import { FeatureFlagTool } from '@utils/feature-flags/feature-flag-tool.tsx';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-datepicker/dist/react-datepicker.css';
import '@liveblocks/react-ui/styles.css';
import '@liveblocks/react-ui/styles/dark/attributes.css';
import '@styles/liveblocks.css';
import '@styles/index.css';

new FeatureFlagTool();

const router = createBrowserRouter(routes);

ReactDOM.createRoot(document.getElementById('root')!).render(
  // HelmetProvider must go OUTSIDE of React.StrictMode
  <HelmetProvider>
    <React.StrictMode>
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </React.StrictMode>
  </HelmetProvider>
);
